/**
 * Define all of your application routes here
 * for more information on routes,
 * official documentation https://router.vuejs.org/en/
 */
import DashboardView from '@/views/DashboardView.vue'
import LoginHome from '@/views/LoginHome.vue'
import LoginForm from '@/views/LoginForm.vue'
// import LoginFormSso from '@/views/LoginFormSso.vue'
import Page404 from '@/views/404.vue'
import Page403 from '@/views/403.vue'
import UserVerification from '@/views/UserVerification.vue'
import FileVerification from '@/views/FileVerification.vue'
import DummyPage from '@/views/DummyPage.vue'

import Organisasi from '@/views/organisasi/Daftar.vue'
import DetailOrganisasi from '@/views/organisasi/Detail.vue'
import TambahOrganisasi from '@/views/organisasi/Tambah.vue'
import UbahOrganisasi from '@/views/organisasi/Ubah.vue'
import JenisDokumenOrganisasi from '@/views/jenisDokumenOrganisasi/Daftar.vue'
import TambahJenisDokumenOrganisasi from '@/views/jenisDokumenOrganisasi/Tambah.vue'
import JenisDokumen from '@/views/jenisDokumen/Daftar.vue'
import TambahJenisDokumen from '@/views/jenisDokumen/Tambah.vue'
import UbahJenisDokumen from '@/views/jenisDokumen/Ubah.vue'

import Pengguna from '@/views/pengguna/Daftar.vue'
import DetailPengguna from '@/views/pengguna/Detail.vue'
import TambahPengguna from '@/views/pengguna/Tambah.vue'
import UbahPengguna from '@/views/pengguna/Ubah.vue'
import Profil from '@/views/pengguna/Profil.vue'
import UbahProfil from '@/views/pengguna/UbahProfil.vue'
import Password from '@/views/pengguna/Password.vue'

import LogAktivitas from '@/views/logAktivitas/LogAktivitas.vue'
import DetailLogAktivitas from '@/views/logAktivitas/Detail.vue'

import Pengaturan from '@/views/pengaturan/Daftar.vue'
import UbahPengaturan from '@/views/pengaturan/Ubah.vue'

import PengaturanEksternal from '@/views/pengaturanEksternal/Daftar.vue'
import TambahPengaturanEksternal from '@/views/pengaturanEksternal/Tambah.vue'
import DetailPengaturanEksternal from '@/views/pengaturanEksternal/Detail.vue'
import UbahPengaturanEksternal from '@/views/pengaturanEksternal/Ubah.vue'

import Menu from '@/views/menu/Daftar.vue'
import DetailMenuPeran from '@/views/menu/Detail.vue'

import PengajuanDokumen from '@/views/sign/Pengajuan.vue'
import PengajuanExternalDokumen from '@/views/sign/PengajuanExternal.vue'
import PenandatangananDokumen from '@/views/sign/Sign.vue'
import PenandatangananDokumenBatch from '@/views/sign/SignBatch.vue'
import DaftarDokumen from '@/views/sign/Daftar.vue'
import DaftarBatch from '@/views/sign/DaftarBatch.vue'
// import DaftarDokumenTabs from '@/views/sign/DaftarTabs.vue'
import DaftarDokumenReject from '@/views/sign/Reject.vue'
import DetailDokumen from '@/views/sign/Detail.vue'
import DetailBatch from '@/views/sign/DetailBatch.vue'
import DetailSignBatch from '@/views/sign/DetailSignBatch.vue'
import DaftarNotifikasi from '@/views/notifikasi/Daftar.vue'
import PanduanPengguna from '@/views/help/Panduan.vue'

import checksso from '@/views/silent-check-sso.vue'

import { chatUrl, frontendUrl, clientId, loggingUrl, ssoUrl, userManagementUrl } from '../config/env'



export default [
  {
    path: '/',
    component: LoginHome,
    children: [
      { path: '', redirect: '/home-page' },
      {
        path: '/home-page',
        name: 'HOME',
        component: LoginForm,
        meta: { loginForm: true },
      },
      {
        path: '/logout',
        name: 'LOGOUT',
        component: LoginForm,
        meta: { loginForm: true },
      },
      {
        path: '/silent-check-sso',
        name: 'CheckSso',
        component: checksso,
        meta: { loginForm: true },
      },
      // {
      //   path: '/ssoLogin',
      //   name: 'LOGIN_HOME',
      //   component: LoginFormSso,
      //   props: route => ({ token: route.query.token }),
      //   meta: { loginForm: true },
      // },
      {
        path: '/404',
        name: '404',
        component: Page404,
        meta: { Page404: true },
      },
      {
        path: '/403',
        name: '403',
        component: Page403,
        meta: { Page403: true },
      },
      {
        path: '/verify',
        name: 'UserVerification',
        component: UserVerification,
        meta: { loginForm: true },
      },
      {
        path: '/verify-file',
        name: 'File Verification',
        component: FileVerification,
        props: route => ({ id_arsip_dokumen: route.query.id_arsip_dokumen, tipe: route.query.tipe})
        // meta: { fileVerificationForm: false },
      },
      {
        path: '/dummy',
        name: 'Dummy Page',
        component: DummyPage,
      },
    ],
  },
  {
    path: '/dashboard-view',
    component: DashboardView,
    children: [
      {
        path: '/notification',
        name: 'Notifikasi',
        component: DaftarNotifikasi,
        meta: { requiresAuth: true },
      },
      {
        // Panduan dapat dibuka semua peran; isi tab disaring di dalam halaman.
        path: '/help',
        name: 'Panduan Pengguna',
        component: PanduanPengguna,
        meta: { requiresAuth: true, allRoles: true },
      },
      {
        path: '/profil',
        name: 'LOGIN_HOME',
        component: Profil,
        meta: { requiresAuth: true },
      },
      {
        path: '/profil/ubah',
        name: 'Ubah Profil',
        component: UbahProfil,
        meta: { requiresAuth: true },
      },
      {
        path: '/ganti-password',
        name: 'Ganti Password',
        component: Password,
        meta: { requiresAuth: true },
      },
      {
        path: '/organisasi',
        name: 'Daftar Organisasi',
        component: Organisasi,
        meta: { requiresAuth: true },
      },
      {
        path: '/detail-organisasi/:kodeorg',
        name: 'Detail Organisasi',
        component: DetailOrganisasi,
        meta: { requiresAuth: true },
      },
      {
        path: '/tambah-organisasi',
        name: 'Tambah Organisasi',
        component: TambahOrganisasi,
        meta: { requiresAuth: true },
      },
      {
        path: '/ubah-organisasi/:kodeorg',
        name: 'Ubah Organisasi',
        component: UbahOrganisasi,
        meta: { requiresAuth: true },
      },
      {
        path: '/jenis-dokumen-organisasi',
        name: 'Daftar Jenis Dokumen Organisasi',
        component: JenisDokumenOrganisasi,
        meta: { requiresAuth: true },
      },
      {
        path: '/jenis-dokumen-organisasi/tambah',
        name: 'Tambah Jenis Dokumen Organisasi',
        component: TambahJenisDokumenOrganisasi,
        meta: { requiresAuth: true },
      },
      {
        path: '/jenis-dokumen-organisasi/ubah/:id',
        name: 'Ubah Jenis Dokumen Organisasi',
        component: TambahJenisDokumenOrganisasi,
        meta: { requiresAuth: true },
      },
      {
        path: '/jenis-dokumen-organisasi/detail/:id',
        name: 'Detail Jenis Dokumen Organisasi',
        component: TambahJenisDokumenOrganisasi,
        meta: { requiresAuth: true },
      },
      {
        path: '/jenis-dokumen',
        name: 'Daftar Jenis Dokumen',
        component: JenisDokumen,
        meta: { requiresAuth: true },
      },
      {
        path: '/tambah-jenis-dokumen',
        name: 'Tambah Jenis Dokumen',
        component: TambahJenisDokumen,
        meta: { requiresAuth: true },
      },
      {
        path: '/ubah-jenis-dokumen/:id',
        name: 'Ubah Jenis Dokumen',
        component: UbahJenisDokumen,
        meta: { requiresAuth: true },
      },
      {
        path: '/submit',
        name: 'Pengajuan Tandatangan Dokumen',
        component: PengajuanDokumen,
        meta: { requiresAuth: true },
      },
      {
        path: '/ext/submit',
        name: 'Pengajuan Tandatangan Dokumen External',
        component: PengajuanExternalDokumen,
        meta: { pengajuanExternal: true },
        props: route => ({ id_jenis_dokumen_organisasi: route.query.id_jenis_dokumen_organisasi, code_override: route.query.code_override, code_transaction: route.query.code_transaction, source: route.query.source, file_name: route.query.file_name, pengguna_entry: route.query.pengguna_entry, nomor_surat: route.query.nomor_surat, token: route.query.token }),
      },
      {
        path: '/dokumen/detail/:id',
        name: 'Detail Dokumen',
        component: DetailDokumen,
        meta: { requiresAuth: true },
      },
      {
        path: '/batch/detail/:id',
        name: 'Detail Batch',
        component: DetailBatch,
        meta: { requiresAuth: true },
      },
      {
        path: '/batch',
        name: 'Daftar Batch',
        component: DaftarBatch,
        meta: { requiresAuth: true },
      },
      {
        path: '/dokumen',
        name: 'Daftar Dokumen',
        component: DaftarDokumen,
        meta: { requiresAuth: true },
      },
      {
        path: '/reject-dokumen',
        name: 'Daftar Penolakan',
        component: DaftarDokumenReject,
        meta: { requiresAuth: true },
      },
      {
        path: '/sign',
        name: 'Daftar Permohonan Tandatangan',
        component: PenandatangananDokumen,
        meta: { requiresAuth: true },
      },
      {
        path: '/batch-sign',
        name: 'Daftar Permohonan Tandatangan Batch',
        component: PenandatangananDokumenBatch,
        meta: { requiresAuth: true },
        props: route => ({ batchName: route.query.batchName})
      },
      {
        path: '/batch-sign/detail/:id',
        name: 'Detail Tandatangan Batch',
        component: DetailSignBatch,
        meta: { requiresAuth: true },
      },
      {
        path: '/pengguna',
        name: 'Daftar Pengguna',
        component: Pengguna,
        meta: { requiresAuth: true },
      },
      {
        path: '/pengguna/detail/:id',
        name: 'Detail Pengguna',
        component: DetailPengguna,
        meta: { requiresAuth: true },
      },
      {
        path: '/pengguna/tambah',
        name: 'Tambah Pengguna',
        component: TambahPengguna,
        meta: { requiresAuth: true },
      },
      {
        path: '/pengguna/ubah/:id',
        name: 'Ubah Pengguna',
        component: UbahPengguna,
        meta: { requiresAuth: true },
      },
      {
        path: '/log-aktivitas',
        name: 'Daftar Log Aktivitas',
        component: LogAktivitas,
        meta: { requiresAuth: true },
      },
      {
        path: '/log-aktivitas/detail/:id',
        name: 'Detail Log Aktivitas',
        component: DetailLogAktivitas,
        meta: { requiresAuth: true },
      },
      {
        path: '/pengaturan',
        name: 'Daftar Pengaturan',
        component: Pengaturan,
        meta: { requiresAuth: true },
      },
      {
        path: '/pengaturan/ubah/:id',
        name: 'Ubah Pengaturan',
        component: UbahPengaturan,
        meta: { requiresAuth: true },
      },
      {
        path: '/pengaturan-eksternal',
        name: 'Daftar Pengaturan Eksternal',
        component: PengaturanEksternal,
        meta: { requiresAuth: true },
      },
      {
        path: '/pengaturan-eksternal/tambah',
        name: 'Tambah Pengaturan Eksternal',
        component: TambahPengaturanEksternal,
        meta: { requiresAuth: true },
      },
      {
        path: '/pengaturan-eksternal/detail/:app_id',
        name: 'Detail Pengaturan Eksternal',
        component: DetailPengaturanEksternal,
        meta: { requiresAuth: true },
      },
      {
        path: '/pengaturan-eksternal/ubah/:app_id',
        name: 'Ubah Pengaturan Eksternal',
        component: UbahPengaturanEksternal,
        meta: { requiresAuth: true },
      },

      {
        path: '/menu',
        name: 'Daftar Menu',
        component: Menu,
        meta: { requiresAuth: true },
      },
      {
        path: '/menu/peran/:id',
        name: 'Detail UAM Peran',
        component: DetailMenuPeran,
        meta: { requiresAuth: true },
      },
      // {
      //   path: '/menu/detail/:id',
      //   name: 'Detail Menu',
      //   component: DetailMenu,
      //   meta: { requiresAuth: true },
      // },
      // {
      //   path: '/menu/tambah',
      //   name: 'Tambah Menu',
      //   component: TambahMenu,
      //   meta: { requiresAuth: true },
      // },
      // {
      //   path: '/menu/ubah/:id',
      //   name: 'Ubah Menu',
      //   component: UbahMenu,
      //   meta: { requiresAuth: true },
      // },
    ],
  },
]
